<template>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'Loading',
		data() {
			return {
				baseUrl: "",
				test: 'false'
			}
		},
		methods: {
			ToCenter() {
				var that = this;
				sessionStorage.setItem('to', 'center')
				sessionStorage.removeItem('landType')
				that.$router.push({
					name: 'Loading'
				});
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "http://xs.weapi.org";
				that.test = 'true';
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://xs.weapi.org";
				that.test = 'true';
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.test = 'false';
			}
			that.baseUrl = baseUrl;
			if(that.test == 'true') {
				if(localStorage.getItem('access_token') == null) {
					sessionStorage.setItem('token_type', 'center')
					that.$router.push({
						name: 'Logo'
					})
				} else {
					$.ajax({
						type: "GET",
						url: that.baseUrl + "/ajax?ugi=loginUgi&action=logininfo",
						dataType: "json",
						async: true,
						data: {
							access_token: localStorage.getItem('access_token')
						},
						success: function(data) {
							if(data.code == 'A00006') {
								that.ToCenter()
							} else {
								sessionStorage.setItem('token_type', 'center')
								that.$router.push({
									name: 'Logo'
								})
							}
						}
					});
				}
			}else if(that.test == 'false'){
				that.ToCenter()
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ToCenter.vue